<template>
  <div class="view-container">
    <transition :name="transitionName">
      <!-- <div style="position: relative;width: 100%;height: 100%;"> -->
      <!-- <router-view class="viewer"></router-view> -->
      <!-- <keep-alive :include="['purchase-cart','management','Home','presell-cart','categorylist','special','seckill','orderManagent']" > -->
        <keep-alive :include="includeArr" >
        <router-view class="viewer"  :key="$route.fullPath" />
      </keep-alive>
      <!-- </div> -->
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import { theme, hexToRGBA } from '~styles/theme.js'
import { mapGetters, mapActions } from 'vuex'
import { ResultCode } from '~const/ResultCode'
export default {
  name: 'App',
  data () {
    return {
      transitionName: '',
      includeArrOrigin: ['purchase-cart', 'management', 'Home', 'presell-cart', 'categorylist', 'special', 'seckill', 'orderManagent'],
      includeArr: []
    }
  },
  computed: {
    ...mapGetters(['getLoginStatus', 'getLoadSettingStatus'])
  },
  created () {
    this.getLoginInfo()
    this.getSetting()
  },
  mounted () {
    Vue.prototype.$keeplive = this.includeArrOrigin
    this.includeArr = Vue.prototype.$keeplive
  },
  methods: {
    ...mapActions(['IS_LOGIN', 'GOODS_NUM', 'LOAD_SETTING_DATA', 'CART_GETNUM']),
    /**
     * @description 获取登录信息
     */
    async getLoginInfo () {
      await this.IS_LOGIN()
      let { status, data } = this.getLoginStatus
      if (status === ResultCode.SUCCESS) {
        window.sessionStorage.setItem('login', data.member_id)
        if (data.member_id.toString() !== '0') { // 登录状态
          var now = (new Date()).valueOf()
          if (data.role.toString() === '1') { // 采购商
            this.CART_GETNUM({ rand: now })
          } else if (data.role.toString() === '2') { // 供应商
            this.CART_GETNUM({ rand: now })
          } else if (data.role.toString() === '3') { // 分销商
            this.GOODS_NUM()
          }
        } else {
          // location.href = '/visitor/login'
        }
      } else {
        location.href = '/visitor/login'
      }
    },
    /**
     * @description 获取后台自定义的颜色：登录按钮颜色，App主题颜色，App字体颜色
     * @author cc
     * @data 2020-3-5
     */
    async getSetting () {
      await this.LOAD_SETTING_DATA()
      let { data } = this.getLoadSettingStatus
      let colorOpacity5 = hexToRGBA(data.style_setting.APP_theme_color, '0.5')
      let colorOpacity3 = hexToRGBA(data.style_setting.APP_theme_color, '0.3')
      let colorOpacity1 = hexToRGBA(data.style_setting.APP_theme_color, '0.1')
      let colorOpacity7 = hexToRGBA(data.style_setting.APP_theme_color, '0.7')

      theme(data.style_setting.APP_login_btn_color, data.style_setting.APP_theme_color, data.style_setting.APP_theme_font_color, colorOpacity5, colorOpacity1, colorOpacity3, colorOpacity7)
    }
  },
  watch: {
    $route (to, from) {
      const fromIndex = from.meta.index
      const toIndex = to.meta.index
      if (toIndex > fromIndex) {
        this.transitionName = 'slide-right'
      } else if (toIndex < fromIndex) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/index.scss";
</style>
